app.filter('capitalize', function() {
    return function(input) {
      try{
        return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
      }catch(e){
        return "";
      }
    }
});